// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".8435e3fe514bee96f85b252d93fa51fe.js";
};